import { createAppAsyncThunk } from 'utils/createAppAsyncThunk';

export const getPaymentChartData = createAppAsyncThunk(
  'charts/getPaymentChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;
      const response = await extra.api.getOrdersChartData(params);

      return response.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getTrialsChartData = createAppAsyncThunk(
  'charts/getTrialsChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;
      const response = await extra.api.getTrialsChartData(params);

      return response.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getCardsChartData = createAppAsyncThunk(
  'charts/getCardsChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;
      const response = await extra.api.getCardsChartData(params);

      return response.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getClientsChartData = createAppAsyncThunk(
  'charts/getClientsChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;
      const response = await extra.api.getClientsChartData(params);

      return response.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getSubscriptionsChartData = createAppAsyncThunk(
  'charts/getSubscriptionsChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;
      const response = await extra.api.getSubscriptionsChartData(params);

      return response.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getSalesFunnelChartData = createAppAsyncThunk(
  'charts/getSalesFunnelChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;
      const response = await extra.api.getSalesFunnelChartData(params);

      return response.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getStatsByProductsChartData = createAppAsyncThunk(
  'charts/getStatsByProductsChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;
      const response = await extra.api.getStatsByProduct(params);

      return response.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getActualStatsByProductsChartData = createAppAsyncThunk(
  'charts/getActualStatsByProductsChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;
      const response = await extra.api.getStatsByProductActual(params);

      return response.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getCommentsChartData = createAppAsyncThunk(
  'charts/getCommentsChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;
      const response = await extra.api.getCommentsChartData(params);

      return { ...response.data };
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getSubscriptionBaseChartData = createAppAsyncThunk(
  'charts/getSubscriptionBaseChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;

      const cleanDate = (str: string) => str.slice(0, 10);

      // Эндпоинт принимает только дату, без времени
      const response = await extra.api.getSubscriptionBaseChartData({
        from: cleanDate(params.from ?? ''),
        to: cleanDate(params.to ?? ''),
      });

      return response.data.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);

export const getPamentsByTariffChartData = createAppAsyncThunk(
  'charts/getPamentsByTariffChartData',
  async (_, { rejectWithValue, extra, getState }) => {
    try {
      const { params } = getState().charts;

      const cleanDate = (str: string) => str.slice(0, 10);

      // Эндпоинт принимает только дату, без времени
      const response = await extra.api.getPamentsByTariffChartData({
        from: cleanDate(params.from ?? ''),
        to: cleanDate(params.to ?? ''),
      });

      return response.data.data;
    } catch (error) {
      //   dispatch(hasError(error));

      return rejectWithValue(error);
    }
  }
);
